/** Roles that may use the Preventive maintenance screens: the single list behind the route guard, the nav item and the calendar's "Open plan" link (docs/design/30 §6, §8). */
export const PLAN_ROLES: readonly string[] = ['FacilityManager', 'AssetManager', 'SystemAdmin'];
